import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function VendorOnboarding() {
  const { refresh } = useAuth();
  const [f, setF] = useState({ business_name: "", about: "", phone: "", city: "", country: "India", website: "" });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { (async () => { try { const r = await api.get("/vendor/profile"); if (r.data?.business_name) setF({ ...f, ...r.data }); } catch (e) { /* ignore */ } })(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/vendor/profile", f);
      await refresh();
      toast.success("Vendor profile saved");
      navigate("/vendor");
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
    setSaving(false);
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-10" data-testid="vendor-onboarding">
      <h1 className="font-display text-3xl font-semibold tracking-tight">Vendor onboarding</h1>
      <p className="text-muted-foreground">Tell travelers about your business.</p>
      <form onSubmit={submit} className="mt-6 rounded-2xl bg-card border border-border p-6 grid gap-3">
        <label className="text-sm">Business name<Input required value={f.business_name} onChange={(e) => setF({ ...f, business_name: e.target.value })} className="mt-1" data-testid="vendor-business-name" /></label>
        <label className="text-sm">About your business<Textarea rows={4} value={f.about} onChange={(e) => setF({ ...f, about: e.target.value })} className="mt-1" data-testid="vendor-about" /></label>
        <div className="grid sm:grid-cols-2 gap-3">
          <label className="text-sm">Phone<Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="mt-1" data-testid="vendor-phone" /></label>
          <label className="text-sm">Website<Input value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} className="mt-1" data-testid="vendor-website" /></label>
          <label className="text-sm">City<Input value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="mt-1" data-testid="vendor-city" /></label>
          <label className="text-sm">Country<Input value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} className="mt-1" data-testid="vendor-country" /></label>
        </div>
        <div className="pt-2">
          <Button type="submit" disabled={saving} className="rounded-xl" data-testid="vendor-onboarding-save">{saving ? "Saving…" : "Save & continue"}</Button>
        </div>
      </form>
    </div>
  );
}
